export { default as Img200 } from './processed/200/Suits_.jpg';
export { default as Img400 } from './processed/400/Suits_.jpg';
export { default as Imgthumb } from './processed/thumb/Suits_.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Suits_.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Suits_.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      148,
      94,
      52
    ],
    "_population": 3,
    "_hsl": [
      0.07291666666666667,
      0.48,
      0.3921568627450981
    ]
  },
  "LightVibrant": {
    "_rgb": [
      220,
      184,
      162
    ],
    "_population": 13,
    "_hsl": [
      0.0632183908045977,
      0.45312500000000017,
      0.7490196078431373
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      84,
      30,
      42
    ],
    "_population": 71,
    "_hsl": [
      0.9629629629629629,
      0.4736842105263158,
      0.22352941176470587
    ]
  },
  "Muted": {
    "_rgb": [
      158,
      114,
      102
    ],
    "_population": 44,
    "_hsl": [
      0.03571428571428571,
      0.224,
      0.5098039215686274
    ]
  },
  "LightMuted": {
    "_rgb": [
      169,
      172,
      204
    ],
    "_population": 3,
    "_hsl": [
      0.6523809523809523,
      0.25547445255474466,
      0.7313725490196079
    ]
  },
  "DarkMuted": {
    "_rgb": [
      60,
      84,
      44
    ],
    "_population": 1,
    "_hsl": [
      0.26666666666666666,
      0.3125,
      0.25098039215686274
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Suits_.js